import { useAppDispatch, useAppSelector } from 'app/config/store';
import { fetchFeedback, fetchFeedbackQuestions } from 'app/entities/meeting/meeting-feedback.reducer';
import React, { useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';

const ViewFeedBack = ({ isOpen, toggle, loading, meetingId }) => {
  const account = useAppSelector(state => state.authentication.account);
  const feedbackList = useAppSelector(state => state.meetingFeedback.feedbackList);

  const list = feedbackList?.feedBackResponse || [];
  const groupByMentor = data => {
    const map = {};

    data.forEach(item => {
      if (!map[item.mentorId]) {
        map[item.mentorId] = [];
      }
      map[item.mentorId].push(item);
    });

    return Object.values(map);
  };
  const grouped = groupByMentor(list);
  const menteeId = account.id;
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isOpen && meetingId && menteeId) {
      console.log('view jsndkjns  ');
      dispatch(fetchFeedback({ menteeId, meetingId }));
    }
  }, [isOpen, meetingId, menteeId]);

  return (
    <Modal className="feedback-overview-pop" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Feedback Overview</ModalHeader>

      <ModalBody className="p-3">
        {loading ? (
          <div className="text-center py-3">
            <Spinner />
          </div>
        ) : list.length > 0 ? (
          <div>
            {grouped.map((mentorGroup: any, index) => {
              const allSameFeedback = mentorGroup.every(item => item.feedBack === mentorGroup[0].feedBack);

              return (
                <div key={index} className="que-box">
                  {allSameFeedback ? (
                    <>
                      {mentorGroup.map((item, i) => (
                        <>
                          <h6 className="text-muted text-start mb-2">Question</h6>
                          <div key={i} className="bg-light text-start border rounded p-2 mb-2">
                            {item.question}
                          </div>
                        </>
                      ))}
                      <h6 className="text-muted text-start mt-3">Feedback </h6>
                      <div className="border rounded p-2 bg-white text-start">{mentorGroup[0].feedBack || 'No feedback provided'}</div>

                      <div className="d-flex justify-content-end">
                        <span className="small text-muted mt-2">— {mentorGroup[0].mentorName ? mentorGroup[0].mentorName : ''}</span>
                      </div>
                    </>
                  ) : (
                    mentorGroup.map((item, i) => (
                      <div key={i}>
                        <h6 className="text-muted text-start mb-2">Question</h6>
                        <div className="bg-light text-start border rounded p-2 mb-2">{item.question}</div>
                        <h6 className="text-muted text-start mt-3">Feedback </h6>
                        <div className="border rounded p-2 bg-white text-start">{item.feedBack}</div>
                        <div className="d-flex justify-content-end">
                          <span className="small text-muted mt-2">— {item.mentorName ? item.mentorName : ''}</span>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-center text-muted">No feedback available</p>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ViewFeedBack;
